import React from 'react';
import { Justify } from 'tea-component';
import ChannelLabel from '../../ChannelLabel';
import { LanguageType } from '@op/types/common';
import { DBO_FEEDS, DBO_V } from '@op/utils/format';
import SvgIcon from '@home/components/SvgIcon';
import useLanguage from '@op/hooks/useLanguage';
import URLShare from '@opm/components/URLShare';
import './index.scss';


type TMetricsList = { key: string; label: string , valueKey: string}[];


interface PostContentItemProps {
    item: any;
    language: LanguageType;
    /** 点击 Details 回调 */
    onClickDetail?: () => void;
    /** Link 按钮的 URL */
    linkUrl?: string;
    /** 点击 Link 回调 */
    onClickLink?: () => void;
    showMetricList?: TMetricsList;
}


// label无意义，做为说明使用
const defaultShowMetricList: TMetricsList = [
    { key: "engagement", label: '互动量', valueKey: "engagement" },
    { key: "likes", label: "点赞", valueKey: "tweets_like" },
    { key: "comment", label: "评论", valueKey: "tweets_reply" },
    { key: "views", label: "观看数", valueKey: "view" }]


/**
 * 单条帖子/评论内容项
 * 展示渠道标签 + 内容文本 + 互动量 + 操作栏（reviewer / Details / Link）
 */
export default function PostContentItem({
    item,
    language,
    onClickDetail,
    linkUrl = '',
    onClickLink,
    showMetricList = defaultShowMetricList
}: PostContentItemProps) {
    const { formatMessage } = useLanguage();

    return (
        <div className="dbo-PostContentItem-wrapper">
            <div className="dbo-PostContentItem-item">
                <ChannelLabel
                    channel_name={item.channel_name}
                    showText={false}
                />
                <span className="dbo-PostContentItem-text">
                    {DBO_FEEDS.content(item, language)}
                </span>
                <div className="dbo-PostContentItem-engagement-list">
                    {showMetricList?.map?.(({ key, valueKey }, _index: number) => {
                        const value = item[valueKey]
                        return <span key={key} className={`dbo-PostContentItem-engagement dbo-PostContentItem-engagement--${key}`}>
                            <span className="dbo-PostContentItem-engagement__icon" />
                            <span className="dbo-PostContentItem-engagement__value">
                                {DBO_V.reviews(value)}
                            </span>
                        </span>
                    }
                    )}
                </div>
            </div>
            <div className="dbo-detail-links-operation">
                <Justify
                    left={
                        <div className="dbo-detail-links-operation-left">
                            {item.reviewer ? "@" + item.reviewer : ''}
                        </div>
                    }
                    right={
                        <div className="dbo-detail-links-operation-right">
                            <div
                                className="dbo-detail-links-operation-item"
                                onClick={onClickDetail}
                            >
                                <SvgIcon type="view-details-icon" />
                                <span>{formatMessage("Details")}</span>
                            </div>
                            <URLShare
                                className="dbo-detail-links-operation-item"
                                btnText={<span>{formatMessage("Link")}</span>}
                                url={linkUrl}
                                onClick={onClickLink}
                            />
                        </div>
                    }
                />
            </div>
        </div>
    );
}
